import { render, staticRenderFns } from "./Tendencias.vue?vue&type=template&id=4622806c&"
import script from "./Tendencias.vue?vue&type=script&lang=js&"
export * from "./Tendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports